require('./splitLineDialog.less');

class SplitLineDialogController {
    deliveryDate;
    orderLine;
    promise;
    splitDetails:{deliveryDate:Date,quantity:number};
    splitLineForm;
    datePlaceholder = "Leveringsdato";

    constructor(private toastService, private OrderLines, private $filter, private $mdDialog){
    }
    $onInit() {
        const isNotOutdated =
            this.orderLine.availableFromDate &&
            new Date(this.orderLine.availableFromDate).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0);
        const availableFromDate =
            isNotOutdated ? new Date(this.orderLine.availableFromDate)
            : null;
        this.deliveryDate =
            availableFromDate ? availableFromDate
            : this.orderLine.deliveryDate ? new Date(this.orderLine.deliveryDate)
            : null;
        this.splitDetails = {
            deliveryDate:  null,
            quantity: 1
        };
    }

    splitLine(){
        this.splitDetails.deliveryDate = this.$filter('date')(this.deliveryDate, 'yyyy-MM-dd');
        this.promise = this.OrderLines.split({lineId:this.orderLine.uniqueId}, this.splitDetails).$promise.then(
            ()=>{
                this.toastService.showSimpleToast("Ordrelinje splittet!", 3000);
                this.$mdDialog.hide();
            },
            (error)=>this.toastService.parseError(error)
        );
    }

    isHighlighted (){
        return (date)=>{
            if(this.orderLine.routeDays === 0){
                return true;
            }
            const dayString = (date.getDay() || 7).toString(); // Sets sundays to 7 ( === 0)
            return this.orderLine.routeDaysString.includes(dayString);
        };
    };

    closeModal(){
        this.$mdDialog.cancel();
    }
}

class SplitLineDialogOptions implements ng.IComponentOptions {
    controller = 'rkcSplitLineDialogController';
    controllerAs = "c";
    template:any = require('./splitLineDialog.html');
    bindings: any = {
        orderLine:'=',
        promise:'='
    };
}

rkcApp.controller("rkcSplitLineDialogController", ['toastService','OrderLines','$filter','$mdDialog',
    function (toastService, OrderLines, $filter, $mdDialog) {
        return new SplitLineDialogController(toastService, OrderLines, $filter, $mdDialog);
    }])
    .component("rkcSplitLineDialog", new SplitLineDialogOptions())
;


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/orderDetails/orderLinesTable/splitLineDialog/splitLineDialog.ts
 **/